namespace TabAurous.Purchase {
    export namespace PurchaseMasterService {
        export const baseUrl = 'Purchase/PurchaseMaster';

        export declare function Create(request: Serenity.SaveRequest<PurchaseMasterRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PurchaseMasterRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PurchaseMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<PurchaseMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetLineNo(request: Serenity.ServiceRequest, onSuccess?: (response: GetLineNoResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function PostedTransIdList(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<PurchaseMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function APIImportSales(request: TransactionRequest, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Purchase/PurchaseMaster/Create",
            Update = "Purchase/PurchaseMaster/Update",
            Delete = "Purchase/PurchaseMaster/Delete",
            Retrieve = "Purchase/PurchaseMaster/Retrieve",
            List = "Purchase/PurchaseMaster/List",
            GetLineNo = "Purchase/PurchaseMaster/GetLineNo",
            PostedTransIdList = "Purchase/PurchaseMaster/PostedTransIdList",
            APIImportSales = "Purchase/PurchaseMaster/APIImportSales"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'GetLineNo', 
            'PostedTransIdList', 
            'APIImportSales'
        ].forEach(x => {
            (<any>PurchaseMasterService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
